// @ts-nocheck

/**
 * YPM_PROJECT_SRV
 * Project  ## Entity Data Model ![ER Diagram](https://yuml.me/diagram/class/[Project{bg:orange}],[Project]-*>[Task],[Task{bg:orange}],[ProjectSet{bg:dodgerblue}]++-*>[Project],[TaskSet{bg:dodgerblue}]++-*>[Task])  ### Legend ![Legend](https://yuml.me/diagram/plain;dir:TB;scale:60/class/[External.Type{bg:whitesmoke}],[ComplexType],[EntityType{bg:orange}],[EntitySet/Singleton/Operation{bg:dodgerblue}])
 *
 * The version of the OpenAPI document: 0001
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ModelError } from '../model/models';
import { ModifiedTask } from '../model/models';
import { Task } from '../model/models';
import { Wrapper1 } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class TaskSetService {

    protected basePath = 'https://sapd42c00.sap.corp.lego.com:22000/sap/opu/odata/sap/YPM_PROJECT_SRV';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Get entities from related toTask
     * @param projectGuid UUID in X form (binary)
     * @param $filter Filter items by property values, see [Filtering](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;64)
     * @param $inlinecount Include count of items, see [Inlinecount](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;67)
     * @param $select Select properties to be returned, see [Select](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;68)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public projectSetProjectGuidToTaskGet(projectGuid: string, $filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'projectGuid' | 'taskGuid' | 'taskLevel' | 'objectType' | 'taskType' | 'explanation' | 'status' | 'sortNumber' | 'process' | 'processText' | 'fixedStartConstraintType' | 'fixedStartConstraintText' | 'fixedStartDate' | 'fixedFinishConstraintType' | 'fixedFinishConstraintText' | 'fixedFinishDate' | 'calculatedEarlyStartDate' | 'calculatedEarlyFinishDate' | 'calculatedLateStartDate' | 'calculatedLateFinishDate' | 'actualStartDate' | 'actualFinishDate' | 'forecastedStart' | 'forecastedFinish' | 'changeTime'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Wrapper1>;
    public projectSetProjectGuidToTaskGet(projectGuid: string, $filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'projectGuid' | 'taskGuid' | 'taskLevel' | 'objectType' | 'taskType' | 'explanation' | 'status' | 'sortNumber' | 'process' | 'processText' | 'fixedStartConstraintType' | 'fixedStartConstraintText' | 'fixedStartDate' | 'fixedFinishConstraintType' | 'fixedFinishConstraintText' | 'fixedFinishDate' | 'calculatedEarlyStartDate' | 'calculatedEarlyFinishDate' | 'calculatedLateStartDate' | 'calculatedLateFinishDate' | 'actualStartDate' | 'actualFinishDate' | 'forecastedStart' | 'forecastedFinish' | 'changeTime'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Wrapper1>>;
    public projectSetProjectGuidToTaskGet(projectGuid: string, $filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'projectGuid' | 'taskGuid' | 'taskLevel' | 'objectType' | 'taskType' | 'explanation' | 'status' | 'sortNumber' | 'process' | 'processText' | 'fixedStartConstraintType' | 'fixedStartConstraintText' | 'fixedStartDate' | 'fixedFinishConstraintType' | 'fixedFinishConstraintText' | 'fixedFinishDate' | 'calculatedEarlyStartDate' | 'calculatedEarlyFinishDate' | 'calculatedLateStartDate' | 'calculatedLateFinishDate' | 'actualStartDate' | 'actualFinishDate' | 'forecastedStart' | 'forecastedFinish' | 'changeTime'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Wrapper1>>;
    public projectSetProjectGuidToTaskGet(projectGuid: string, $filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'projectGuid' | 'taskGuid' | 'taskLevel' | 'objectType' | 'taskType' | 'explanation' | 'status' | 'sortNumber' | 'process' | 'processText' | 'fixedStartConstraintType' | 'fixedStartConstraintText' | 'fixedStartDate' | 'fixedFinishConstraintType' | 'fixedFinishConstraintText' | 'fixedFinishDate' | 'calculatedEarlyStartDate' | 'calculatedEarlyFinishDate' | 'calculatedLateStartDate' | 'calculatedLateFinishDate' | 'actualStartDate' | 'actualFinishDate' | 'forecastedStart' | 'forecastedFinish' | 'changeTime'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (projectGuid === null || projectGuid === undefined) {
            throw new Error('Required parameter projectGuid was null or undefined when calling projectSetProjectGuidToTaskGet.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$filter, '$filter');
        }
        if ($inlinecount !== undefined && $inlinecount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$inlinecount, '$inlinecount');
        }
        if ($select) {
            queryParameters = this.addToHttpParams(queryParameters,
                $select.join(COLLECTION_FORMATS['csv']), '$select');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Wrapper1>(`${this.configuration.basePath}/ProjectSet(${encodeURIComponent(String(projectGuid))})/toTask`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get entities from TaskSet
     * @param $filter Filter items by property values, see [Filtering](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;64)
     * @param $inlinecount Include count of items, see [Inlinecount](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;67)
     * @param $select Select properties to be returned, see [Select](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;68)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public taskSetGet($filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'projectGuid' | 'taskGuid' | 'taskLevel' | 'objectType' | 'taskType' | 'explanation' | 'status' | 'sortNumber' | 'process' | 'processText' | 'fixedStartConstraintType' | 'fixedStartConstraintText' | 'fixedStartDate' | 'fixedFinishConstraintType' | 'fixedFinishConstraintText' | 'fixedFinishDate' | 'calculatedEarlyStartDate' | 'calculatedEarlyFinishDate' | 'calculatedLateStartDate' | 'calculatedLateFinishDate' | 'actualStartDate' | 'actualFinishDate' | 'forecastedStart' | 'forecastedFinish' | 'changeTime'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Wrapper1>;
    public taskSetGet($filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'projectGuid' | 'taskGuid' | 'taskLevel' | 'objectType' | 'taskType' | 'explanation' | 'status' | 'sortNumber' | 'process' | 'processText' | 'fixedStartConstraintType' | 'fixedStartConstraintText' | 'fixedStartDate' | 'fixedFinishConstraintType' | 'fixedFinishConstraintText' | 'fixedFinishDate' | 'calculatedEarlyStartDate' | 'calculatedEarlyFinishDate' | 'calculatedLateStartDate' | 'calculatedLateFinishDate' | 'actualStartDate' | 'actualFinishDate' | 'forecastedStart' | 'forecastedFinish' | 'changeTime'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Wrapper1>>;
    public taskSetGet($filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'projectGuid' | 'taskGuid' | 'taskLevel' | 'objectType' | 'taskType' | 'explanation' | 'status' | 'sortNumber' | 'process' | 'processText' | 'fixedStartConstraintType' | 'fixedStartConstraintText' | 'fixedStartDate' | 'fixedFinishConstraintType' | 'fixedFinishConstraintText' | 'fixedFinishDate' | 'calculatedEarlyStartDate' | 'calculatedEarlyFinishDate' | 'calculatedLateStartDate' | 'calculatedLateFinishDate' | 'actualStartDate' | 'actualFinishDate' | 'forecastedStart' | 'forecastedFinish' | 'changeTime'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Wrapper1>>;
    public taskSetGet($filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'projectGuid' | 'taskGuid' | 'taskLevel' | 'objectType' | 'taskType' | 'explanation' | 'status' | 'sortNumber' | 'process' | 'processText' | 'fixedStartConstraintType' | 'fixedStartConstraintText' | 'fixedStartDate' | 'fixedFinishConstraintType' | 'fixedFinishConstraintText' | 'fixedFinishDate' | 'calculatedEarlyStartDate' | 'calculatedEarlyFinishDate' | 'calculatedLateStartDate' | 'calculatedLateFinishDate' | 'actualStartDate' | 'actualFinishDate' | 'forecastedStart' | 'forecastedFinish' | 'changeTime'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$filter, '$filter');
        }
        if ($inlinecount !== undefined && $inlinecount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$inlinecount, '$inlinecount');
        }
        if ($select) {
            queryParameters = this.addToHttpParams(queryParameters,
                $select.join(COLLECTION_FORMATS['csv']), '$select');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Wrapper1>(`${this.configuration.basePath}/TaskSet`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get entity from TaskSet by key
     * @param projectGuid Project Guid
     * @param taskGuid Task Guid
     * @param $select Select properties to be returned, see [Select](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;68)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public taskSetProjectGuidprojectGuidtaskGuidtaskGuidGet(projectGuid: string, taskGuid: string, $select?: Array<'projectGuid' | 'taskGuid' | 'taskLevel' | 'objectType' | 'taskType' | 'explanation' | 'status' | 'sortNumber' | 'process' | 'processText' | 'fixedStartConstraintType' | 'fixedStartConstraintText' | 'fixedStartDate' | 'fixedFinishConstraintType' | 'fixedFinishConstraintText' | 'fixedFinishDate' | 'calculatedEarlyStartDate' | 'calculatedEarlyFinishDate' | 'calculatedLateStartDate' | 'calculatedLateFinishDate' | 'actualStartDate' | 'actualFinishDate' | 'forecastedStart' | 'forecastedFinish' | 'changeTime'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Task>;
    public taskSetProjectGuidprojectGuidtaskGuidtaskGuidGet(projectGuid: string, taskGuid: string, $select?: Array<'projectGuid' | 'taskGuid' | 'taskLevel' | 'objectType' | 'taskType' | 'explanation' | 'status' | 'sortNumber' | 'process' | 'processText' | 'fixedStartConstraintType' | 'fixedStartConstraintText' | 'fixedStartDate' | 'fixedFinishConstraintType' | 'fixedFinishConstraintText' | 'fixedFinishDate' | 'calculatedEarlyStartDate' | 'calculatedEarlyFinishDate' | 'calculatedLateStartDate' | 'calculatedLateFinishDate' | 'actualStartDate' | 'actualFinishDate' | 'forecastedStart' | 'forecastedFinish' | 'changeTime'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Task>>;
    public taskSetProjectGuidprojectGuidtaskGuidtaskGuidGet(projectGuid: string, taskGuid: string, $select?: Array<'projectGuid' | 'taskGuid' | 'taskLevel' | 'objectType' | 'taskType' | 'explanation' | 'status' | 'sortNumber' | 'process' | 'processText' | 'fixedStartConstraintType' | 'fixedStartConstraintText' | 'fixedStartDate' | 'fixedFinishConstraintType' | 'fixedFinishConstraintText' | 'fixedFinishDate' | 'calculatedEarlyStartDate' | 'calculatedEarlyFinishDate' | 'calculatedLateStartDate' | 'calculatedLateFinishDate' | 'actualStartDate' | 'actualFinishDate' | 'forecastedStart' | 'forecastedFinish' | 'changeTime'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Task>>;
    public taskSetProjectGuidprojectGuidtaskGuidtaskGuidGet(projectGuid: string, taskGuid: string, $select?: Array<'projectGuid' | 'taskGuid' | 'taskLevel' | 'objectType' | 'taskType' | 'explanation' | 'status' | 'sortNumber' | 'process' | 'processText' | 'fixedStartConstraintType' | 'fixedStartConstraintText' | 'fixedStartDate' | 'fixedFinishConstraintType' | 'fixedFinishConstraintText' | 'fixedFinishDate' | 'calculatedEarlyStartDate' | 'calculatedEarlyFinishDate' | 'calculatedLateStartDate' | 'calculatedLateFinishDate' | 'actualStartDate' | 'actualFinishDate' | 'forecastedStart' | 'forecastedFinish' | 'changeTime'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (projectGuid === null || projectGuid === undefined) {
            throw new Error('Required parameter projectGuid was null or undefined when calling taskSetProjectGuidprojectGuidtaskGuidtaskGuidGet.');
        }
        if (taskGuid === null || taskGuid === undefined) {
            throw new Error('Required parameter taskGuid was null or undefined when calling taskSetProjectGuidprojectGuidtaskGuidtaskGuidGet.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($select) {
            queryParameters = this.addToHttpParams(queryParameters,
                $select.join(COLLECTION_FORMATS['csv']), '$select');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Task>(`${this.configuration.basePath}/TaskSet(projectGuid=${encodeURIComponent(String(projectGuid))},taskGuid=${encodeURIComponent(String(taskGuid))})`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update entity in TaskSet
     * @param projectGuid Project Guid
     * @param taskGuid Task Guid
     * @param modifiedTask 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public taskSetProjectGuidprojectGuidtaskGuidtaskGuidPatch(projectGuid: string, taskGuid: string, modifiedTask: ModifiedTask, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<any>;
    public taskSetProjectGuidprojectGuidtaskGuidtaskGuidPatch(projectGuid: string, taskGuid: string, modifiedTask: ModifiedTask, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<any>>;
    public taskSetProjectGuidprojectGuidtaskGuidtaskGuidPatch(projectGuid: string, taskGuid: string, modifiedTask: ModifiedTask, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<any>>;
    public taskSetProjectGuidprojectGuidtaskGuidtaskGuidPatch(projectGuid: string, taskGuid: string, modifiedTask: ModifiedTask, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (projectGuid === null || projectGuid === undefined) {
            throw new Error('Required parameter projectGuid was null or undefined when calling taskSetProjectGuidprojectGuidtaskGuidtaskGuidPatch.');
        }
        if (taskGuid === null || taskGuid === undefined) {
            throw new Error('Required parameter taskGuid was null or undefined when calling taskSetProjectGuidprojectGuidtaskGuidtaskGuidPatch.');
        }
        if (modifiedTask === null || modifiedTask === undefined) {
            throw new Error('Required parameter modifiedTask was null or undefined when calling taskSetProjectGuidprojectGuidtaskGuidtaskGuidPatch.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.patch<any>(`${this.configuration.basePath}/TaskSet(projectGuid=${encodeURIComponent(String(projectGuid))},taskGuid=${encodeURIComponent(String(taskGuid))})`,
            modifiedTask,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
